import React from 'react';
import styled from 'styled-components';
import { Search } from 'lucide-react';

interface SearchInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  className?: string;
  disabled?: boolean;
}

const SearchContainer = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;
  transition: ${props => props.theme.transitionSmooth};
  
  @media (max-width: 640px) {
    min-width: 0;
    max-width: none;
    flex: 0 0 auto;
  }
`;

const SearchIcon = styled(Search)`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: ${props => props.theme.mutedForeground};
  width: 16px;
  height: 16px;
  z-index: 1;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 0.625rem 1rem 0.625rem 2.5rem;
  border: 1px solid ${props => props.theme.border};
  border-radius: ${props => props.theme.radius};
  background: ${props => props.theme.background};
  color: ${props => props.theme.foreground};
  font-size: 0.875rem;
  line-height: 1.25rem;
  transition: ${props => props.theme.transitionSmooth};
  
  &::placeholder {
    color: ${props => props.theme.mutedForeground};
  }
  
  &:focus {
    outline: none;
    border-color: ${props => props.theme.ring};
    box-shadow: 0 0 0 2px ${props => props.theme.ring}20;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SearchInput: React.FC<SearchInputProps> = ({
  placeholder = 'Search...',
  value,
  onChange,
  onSearch,
  className,
  disabled = false
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch();
    }
  };

  return (
    <SearchContainer className={className}>
      <SearchIcon />
      <StyledInput
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
        disabled={disabled}
      />
    </SearchContainer>
  );
}; 